import { createSlice } from '@reduxjs/toolkit';

export type ActiveCompanySliceState = {
  activeCompanyId: string | null;
};

const initialState: ActiveCompanySliceState = {
  activeCompanyId: null,
};

const activeCompanySlice = createSlice({
  name: 'activeCompany',
  initialState,
  reducers: {
    setActiveCompanyId: (state, action) => {
      state.activeCompanyId = action.payload;
    },
    clearActiveCompanyId: (state) => {
      state.activeCompanyId = null;
    },
  },
});

export const { setActiveCompanyId, clearActiveCompanyId } =
  activeCompanySlice.actions;

export const activeCompanyReducer = activeCompanySlice.reducer;
